exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".single-col__item{border-radius:4px}.single-col__item+.single-col__item{margin-top:12px}\n", ""]);

